import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAxiosRequestConfig, newRequest } from 'utils/request.ts'
import { Methods, NewResponse } from 'types/request.ts'
import {
  CreateInternalUserPayload,
  DeleteInternalUserPayload,
  GetInternalUsersResponse,
  UpdateInternalUserPayload
} from 'store/internalUser/thunks/types.ts'

// GET
export const getInternalUsers = createAsyncThunk<GetInternalUsersResponse>('internalUser/getInternalUsers', async (_, thunkAPI) => {
  try {
    const { success, data, message }: NewResponse<GetInternalUsersResponse> = await newRequest(
      getAxiosRequestConfig(Methods.GET, '/users/internal')
    )

    if (!success || !data) {
      return thunkAPI.rejectWithValue(message ?? 'getInternalUsers')
    }

    return { internalUsers: data.internalUsers }
  } catch (err) {
    const { message } = err as Error
    return thunkAPI.rejectWithValue(message)
  }
})

// CREATE
export const createInternalUser = createAsyncThunk<void, CreateInternalUserPayload>(
  'internalUser/createInternalUser',
  async ({ internalUser }, thunkAPI) => {
    try {
      const { success, message } = await newRequest(getAxiosRequestConfig(Methods.POST, '/users/internal', { internalUser }))

      if (!success) {
        return thunkAPI.rejectWithValue(message ?? 'createInternalUser')
      }
    } catch (err) {
      const { message } = err as Error
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// UPDATE
export const updateInternalUser = createAsyncThunk<void, UpdateInternalUserPayload>(
  'internalUser/updateInternalUser',
  async ({ id, internalUser }, thunkAPI) => {
    try {
      const { success, message } = await newRequest(getAxiosRequestConfig(Methods.PATCH, `/users/internal/${id}`, { internalUser }))

      if (!success) {
        return thunkAPI.rejectWithValue(message ?? 'updateInternalUser')
      }
    } catch (err) {
      const { message } = err as Error
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// DELETE
export const deleteInternalUser = createAsyncThunk<void, DeleteInternalUserPayload>(
  'internalUser/deleteInternalUser',
  async ({ id }, thunkAPI) => {
    try {
      const { success, message } = await newRequest(getAxiosRequestConfig(Methods.DELETE, `/users/internal/${id}`))

      if (!success) {
        return thunkAPI.rejectWithValue(message ?? 'deleteInternalUser')
      }

      thunkAPI.dispatch(getInternalUsers())
    } catch (err) {
      const { message } = err as Error
      return thunkAPI.rejectWithValue(message)
    }
  }
)
